import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { Root } from "@definitions";
import { ConditionalMessageNode } from "src/definitions/ui-definitions";
import { ConditionalMessage } from "src/ui/components/widgets/conditional-message/conditional-message";

type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	ConditionalMessageNode
>;

export class ConditionalMessageComponentBuilder
	implements UiComponentBuilder<Root, ConditionalMessageNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(
		node: ConditionalMessageNode,
		context: UiComponentBuildContext<Root>,
	) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node);
		}
	}

	private _render(node: ConditionalMessageNode): ReactElement {
		const { state, type, id, visible, ...props } = node;

		return <ConditionalMessage {...props} />;
	}
}
